import { render, staticRenderFns } from "./ProgramFilter.vue?vue&type=template&id=7c31ea70"
import script from "./ProgramFilter.vue?vue&type=script&lang=ts"
export * from "./ProgramFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports